import { useState } from "react";
import { faqList } from "@/mocks/anime";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600">
            <i className="ri-question-line" />
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            关于追番与本站榜单的常见疑问
          </h2>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            新入坑的观众最常遇到的几个问题，这里一次性讲清楚。点击问题即可展开答案。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqList.map((item, idx) => {
            const isOpen = idx === openIndex;
            return (
              <div
                key={item.q}
                className="rounded-lg bg-background-50 border border-background-200 overflow-hidden"
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpenIndex(isOpen ? null : idx)}
                  className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                    {item.q}
                  </span>
                  <span
                    className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-lg transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50 dark:text-foreground-950" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                  </span>
                </button>
                {isOpen && (
                  <div className="px-4 md:px-5 pb-5 -mt-1">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}